import { render, staticRenderFns } from "./Drepturi_list.vue?vue&type=template&id=45ffc334&scoped=true&"
import script from "./Drepturi_list.vue?vue&type=script&lang=js&"
export * from "./Drepturi_list.vue?vue&type=script&lang=js&"
import style0 from "./Drepturi_list.vue?vue&type=style&index=0&id=45ffc334&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ffc334",
  null
  
)

export default component.exports